module.exports = __webpack_public_path__ + "img/design02.eb7e5d42.png";